// extracted by mini-css-extract-plugin
export var optionGrid = "_49-7";
export var optionList = "_49-6";
export var questionsBlock = "_49-9";
export var spacer = "_49-5";
export var stepCenteredContent = "_49-3";
export var stepInner = "_49-0";
export var stepInnerFullWidth = "_49-1";
export var stepInnerLockScroll = "_49-2";
export var stepTransitionFrame = "_49-4";
export var welcomeBlock = "_49-8";